export const MAX_HOURS_AND_MINUTES = 999999
export const MIN_HOURS_AND_MINUTES = 0
export const DATE_SELECTOR_RANGE = 14
export const SALE_NOTE_MAX_CHAR = 2000
export const THRESHOLD_SALE_NOTE_MAX_CHAR = 400
export const INPUT_MAX_CHAR = 255
export const TEXT_AREA_MAX_CHAR = 2000
